module.exports = __webpack_public_path__ + "assets/img/food_processor_active.748d50af.png";